import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { ConstantsModule } from './../constants/constants.module';

@Component({
	selector: 'app-infos',
	templateUrl: './infos.component.html',
styleUrls: ['./infos.component.scss']
})
export class InfosComponent implements OnInit {
	public infoId: string = "";
	private _userId: string = "";
	private _folderId: string = "";

	// Download error.
	public fileName: string = "";
	public folderName: string = "";

	// Follow.
	public userName: string = "";

	constructor(private activatedRoute:ActivatedRoute, private httpClient:HttpClient, private constantsModule:ConstantsModule) {
		// Loading parameters from the URL.
		this.infoId = this.activatedRoute.snapshot.params.infoid;
		if (this.infoId == undefined) this.infoId = "DEFAULT";
		else this.infoId = this.infoId.toUpperCase();

		switch (this.infoId) {
			case "DOWNLOAD":
				// Downlad on error.
				// Param 1: File Name.
				// Param 2: folderName.
				var param1 = this.activatedRoute.snapshot.params.param1;
				var param2 = this.activatedRoute.snapshot.params.param2;

				if (param1 == undefined) param1 = 'Fichier inconnu';
				if (param2 == undefined) param2 = 'Dossier inconnu';

				this.fileName = param1;
				this.folderName = param2;

				break;
			case "FOLDER-FOLLOW":
				// User Follow.
				// param 1: UserId
				// param 2: FolderId
				var param1 = this.activatedRoute.snapshot.params.param1;
				var param2 = this.activatedRoute.snapshot.params.param2;
				var param3 = this.activatedRoute.snapshot.params.param3;
				var param4 = "FOLLOW";

				var data = {
					userId:param1,
					folderId:param2,
					mode:param3,
					action:param4,
				};

				this.httpClient.post(this.constantsModule.serverFullURL+"/secure/info-follower", data, this.constantsModule.httpOptions).subscribe(
					(res:any) => {
						if (res.RES == "OK") {
							this.userName = res.USERNAME;
							this.folderName = res.FOLDERNAME;
						} else {
							this.infoId = "ERROR";
						}
					},
					(err:any) => {
						this.infoId = "DEFAULT";
					}
				);
				break;
			case "FOLDER-NOTFOLLOW":
				// User will NOT follow a folderId.
				// param 1: UserId.
				// param 2: FolderId
				var param1 = this.activatedRoute.snapshot.params.param1;
				var param2 = this.activatedRoute.snapshot.params.param2;
				var param3 = this.activatedRoute.snapshot.params.param3;
				var param4 = "NOTFOLLOW";

				var data = {
					userId:param1,
					folderId:param2,
					mode:param3,
					action:param4,
				};

				this.httpClient.post(this.constantsModule.serverFullURL+"/secure/info-follower", data,this.constantsModule.httpOptions).subscribe(
					(res:any) => {
						if (res.RES == "OK") {
							this.userName = res.USERNAME;
							this.folderName = res.FOLDERNAME;
						} else {
							this.infoId = "ERROR";
						}
					},
					(err:any) => {
						this.infoId = "ERROR";
					}
				);
				break;
			default:
				this.infoId = "DEFAULT";
				break;
		}

	}

	ngOnInit(): void {
	}

}
